import { updateFormGroupNameOffline } from "../db/queries/formGroupQueries";
import updateFormGroupNameAmplify from "./updateFormGroupNameAmplify";

export default async function _updateFormGroupName(data: { id: string; name: string; group: string }, online: boolean, username: string): Promise<void> {
	const newData = {
		...data,
		updatedAt: new Date().toISOString(),
		lastUpdatedBy: username,
	};
	if (online) {
		await updateFormGroupNameAmplify(newData);
	} else {
		await updateFormGroupNameOffline(newData);
	}
}
